import { render } from "./ContactView.vue?vue&type=template&id=a16c49c0&scoped=true&ts=true"
import script from "./ContactView.vue?vue&type=script&lang=ts"
export * from "./ContactView.vue?vue&type=script&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=a16c49c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16c49c0"]])

export default __exports__